// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fav-modal-data[data-v-2f96dd5a]{margin:2rem}.fav-modal-data .p-inputtext[data-v-2f96dd5a]{width:100%;margin:.5rem 0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
